/**
 * Sessie 55: bijlagen samenvoegen voor het antwoordvak. Label en pakbon
 * van een retour komen van de copiloot (`bijlagen` in het klaar-event) of
 * uit het Sanne-concept (`concept_bijlagen`); ze landen naast wat JP zelf
 * koos, nooit twee keer dezelfde (op id).
 */
import type { V6UitgaandeBijlage } from "./api";

/** Voeg bijlagen toe aan een lijst, zonder dubbele op id. Niets nieuws:
 *  dezelfde lijst terug (zelfde referentie). */
export function voegBijlagenSamen(
  oud: V6UitgaandeBijlage[],
  nieuw: V6UitgaandeBijlage[],
): V6UitgaandeBijlage[] {
  const erbij = nieuw.filter(
    (b, i) => !oud.some((x) => x.id === b.id) && nieuw.findIndex((x) => x.id === b.id) === i,
  );
  return erbij.length ? [...oud, ...erbij] : oud;
}

/** Sleutel van één concept met bijlagen: zaak plus de ids. Een nieuw
 *  concept met andere bijlagen krijgt een nieuwe sleutel. */
export function conceptBijlagenSleutel(
  zaakId: string,
  bijlagen: V6UitgaandeBijlage[] | null | undefined,
): string | null {
  if (!bijlagen || bijlagen.length === 0) return null;
  return `${zaakId}|${bijlagen.map((b) => b.id).join(",")}`;
}
